"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordEye = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var Figure = styled_components_1.default.figure(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 17px;\n  top: 11px;\n\n  img {\n    width: 100%;\n  }\n"], ["\n  position: absolute;\n  right: 17px;\n  top: 11px;\n\n  img {\n    width: 100%;\n  }\n"])));
var PasswordEye = function () {
    return (0, jsx_runtime_1.jsx)(Figure, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/icon-password', alt: 'icon password' }) });
};
exports.PasswordEye = PasswordEye;
var templateObject_1;
